import React from 'react';
import classNames from "classnames";
import { Link } from 'react-router-dom';

import { PuzzleIcon, PhotographIcon, ExternalLinkIcon, BriefcaseIcon, BookmarkIcon, CogIcon } from "@heroicons/react/outline";
import Feature from "Components/Feature";

let navigation = [
    { name: 'Stories', icon: BookmarkIcon, href: '/stories', count: 0, current: false },
    { name: 'Projects', icon: BriefcaseIcon, href: '/projects', count: 0, current: false },
    { name: 'Media', icon: PhotographIcon, href: '/media', count: 0, current: false },
    { name: 'Sharing', icon: ExternalLinkIcon, href: '/sharing', count: 0, current: false },
    { name: 'Integrations', icon: PuzzleIcon, href: '/integrations', count: 0, current: false },
];

export default function Nav({path, minimized}) {

    const isCurrent = href => href === `/${path}`;

    const classes = (current) => classNames(
        'group flex items-center justify-center px-2 py-2 text-sm font-medium rounded-md',
        {
            'bg-indigo-800 text-white': current,
            'text-indigo-100 hover:bg-indigo-600 hover:bg-opacity-75': ! current,
            'lg:justify-start': ! minimized
        }
    );

    return <nav className="mt-5 flex-1 px-2 space-y-1" aria-label="Sidebar">
        {
            navigation.map(
                item => <NavItem
                    key={item.name}
                    className={classes(isCurrent(item.href))}
                    name={item.name}
                    href={item.href}
                    count={item.count}
                    current={isCurrent(item.href)}
                    Icon={item.icon}
                    minimized={minimized}
                />
            )
        }
        <Feature when={features => features.settings}>
            <NavItem
                className={classes(isCurrent('/settings'))}
                name='Settings'
                href='/settings'
                count={null}
                current={isCurrent('/settings')}
                Icon={CogIcon}
                minimized={minimized}
            />
        </Feature>
    </nav>;
}

const NavItem = ({name, href, count, Icon, current, minimized, ...props}) => (
    <Link key={name} to={href} {...props}>
        <Icon className="h-6 w-6 text-indigo-300" aria-hidden="true" />
        <span className={minimized ? `hidden ml-3` : `hidden lg:inline ml-3`}>{name}</span>
        <NavCounter count={count} current={current} />
    </Link>
);

const NavCounter = ({count, current}) => {

    if (! count) {
        return null;
    }

    const classes = classNames(
        'ml-auto inline-block py-0.5 px-3 text-xs font-medium rounded-full hidden lg:inline',
        {
            'bg-indigo-600': current,
            'bg-indigo-800': ! current
        }
    );

    return <span className={classes}>
        {count}
    </span>;
}